import React from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface SearchBarProps {
  query: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({
  query,
  handleChange,
  handleSubmit,
  handleKeyDown,
}) => {
  return (
    <div className="space-y-4 my-4">
      <form onSubmit={handleSubmit} className="relative w-full">
        <Input
          value={query}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          type="search"
          placeholder="Got an AI topic in mind? I’ll dig up the good stuff..."
          className="min-h-16 h-auto resize-none drop-shadow-md pr-12 w-full border-2 border-black bg-white rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          type="submit"
          className="absolute bottom-3 right-3 p-1.5 rounded-full transition-all duration-200 hover:scale-110 text-blue-500 hover:text-blue-600 cursor-pointer"
        >
          <Search className="h-6 w-6 text-black" />
        </button>
      </form>
    </div>
  );
};

export default SearchBar;
